// extracted by mini-css-extract-plugin
export default {"title":"PmaxSelectStep_title__s2eaz","tabs":"PmaxSelectStep_tabs__M2+kd"};